<p-toast></p-toast>
<h2 class="page-title">
  {{ "i18n.domain.client-administration.overview.title" | translate }}
</h2>

<div class="data-table">
  <p-toolbar>
    <ng-template pTemplate="left">
      <p-button
        label="{{
          'i18n.domain.client-administration.overview.add' | translate
        }}"
        icon="pi pi-plus"
        *ngIf="authService.isUserAdmin()"
        (onClick)="openNew()"
      ></p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <app-search-field
        (searchTextChanged)="onSearchTextChanged($event)"
      ></app-search-field>
    </ng-template>
  </p-toolbar>

  <p-table
    [value]="data"
    [rows]="pagedQuery.pageSize"
    [paginator]="true"
    [globalFilterFields]="globalFilters"
    [rowHover]="true"
    dataKey="id"
    [lazy]="true"
    (onFilter)="onFilter($event)"
    (onPage)="onPageChange($event)"
    (onSort)="onSort($event)"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Clients"
    [showCurrentPageReport]="true"
    [totalRecords]="totalNoOfRecords"
    [rowsPerPageOptions]="pagedQuery.getPageSizes()"
    [filterDelay]="0"
    [filters]="columnFilters"
    styleClass="dt-grid"
    [paginatorDropdownAppendTo]="'body'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{ "i18n.shared.fields.name" | translate }}
          <p-sortIcon field="name"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="name"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="address">
          {{ "i18n.shared.fields.address" | translate }}
          <p-sortIcon field="address"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="address"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="zip">
          {{ "i18n.shared.fields.zip" | translate }}
          <p-sortIcon field="zip"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="zip"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="city">
          {{ "i18n.shared.fields.city" | translate }}
          <p-sortIcon field="city"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="city"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="email">
          {{ "i18n.shared.fields.email" | translate }}
          <p-sortIcon field="email"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="email"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="phoneNumber">
          {{ "i18n.shared.fields.phone" | translate }}
          <p-sortIcon field="phoneNumber"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="phoneNumber"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="isActive">
          {{ "i18n.shared.fields.active" | translate }}
          <p-sortIcon field="isActive"></p-sortIcon>
          <p-columnFilter
            type="boolean"
            field="isActive"
            display="menu"
          ></p-columnFilter>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-client>
      <tr>
        <td>{{ client.name }}</td>
        <td>{{ client.address }}</td>
        <td>{{ client.zip }}</td>
        <td>{{ client.city }}</td>
        <td>{{ client.email }}</td>
        <td>{{ client.phoneNumber }}</td>
        <td>
          <p-tag
            [value]="client.isActive ? 'Yes' : 'No'"
            [severity]="client.isActive ? 'success' : 'danger'"
          ></p-tag>
        </td>
        <td>
          <div class="grid-commands">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [outlined]="true"
              severity="success"
              (onClick)="editItem(client)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [rounded]="true"
              [outlined]="true"
              (onClick)="deleteClient(client)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No clients found</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="itemDialog"
    [style]="{ width: '450px' }"
    [modal]="true"
    styleClass="p-fluid"
  >
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <span class="dialog-title">
          {{
            "i18n.domain.client-administration.overview.edit-dialog-title"
              | translate
          }}
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <form [formGroup]="form">
        <div class="field">
          <label for="name" class="control-label required">{{
            "i18n.shared.fields.name" | translate
          }}</label>
          <input id="name" type="text" pInputText formControlName="name" />
          <app-error-messages
            [control]="form.controls.name"
          ></app-error-messages>
        </div>
        <div class="field">
          <label for="address" class="control-label">{{
            "i18n.shared.fields.address" | translate
          }}</label>
          <input
            id="address"
            type="text"
            pInputText
            formControlName="address"
          />
          <app-error-messages
            [control]="form.controls.address"
          ></app-error-messages>
        </div>
        <div class="field">
          <label for="zip" class="control-label">{{
            "i18n.shared.fields.zip" | translate
          }}</label>
          <input id="zip" type="text" pInputText formControlName="zip" />
          <app-error-messages
            [control]="form.controls.zip"
          ></app-error-messages>
        </div>
        <div class="field">
          <label for="city" class="control-label">{{
            "i18n.shared.fields.city" | translate
          }}</label>
          <input id="city" type="text" pInputText formControlName="city" />
          <app-error-messages
            [control]="form.controls.city"
          ></app-error-messages>
        </div>
        <div class="field">
          <label for="email" class="control-label">{{
            "i18n.shared.fields.email" | translate
          }}</label>
          <input id="email" type="text" pInputText formControlName="email" />
          <app-error-messages
            [control]="form.controls.email"
          ></app-error-messages>
        </div>
        <div class="field">
          <label for="phoneNumber" class="control-label">{{
            "i18n.shared.fields.phone" | translate
          }}</label>
          <input
            id="phoneNumber"
            type="text"
            pInputText
            formControlName="phoneNumber"
            placeholder="12 digits (2-digit country code + 10-digit phone)"
            (input)="onPhoneInput($event)"
          />
          <app-error-messages
            [control]="form.controls.phoneNumber"
          ></app-error-messages>
        </div>
        <div class="field-checkbox" *ngIf="isAdmin">
          <p-checkbox
            [binary]="true"
            formControlName="isActive"
            inputId="isActive"
          ></p-checkbox>
          <label for="isActive">
            {{ "i18n.shared.fields.active" | translate }}
          </label>
        </div>
      </form>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button
        label="{{ 'i18n.shared.cancel' | translate }}"
        icon="pi pi-times"
        [text]="true"
        (onClick)="hideDialog()"
      ></p-button>
      <p-button
        label="{{ 'i18n.shared.save' | translate }}"
        icon="pi pi-check"
        [text]="true"
        (onClick)="saveClient()"
        [disabled]="!form.valid"
      ></p-button>
    </ng-template>
  </p-dialog>
</div>
